import { Model } from 'modules/core/lib/mobx-rest'

interface Attributes {
  id: string
  level_id: string
  legal_entities_ids: string[]
  min_range: number
  max_range: number
  currency: string
  salary_frequency: string
  amount_type: 'fixed' | 'range'
}

class JobLevelSalaryRange extends Model<Attributes> {
  static urlRoot() {
    return '/job_catalog/salary_ranges'
  }
}

export default JobLevelSalaryRange
